import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { coursesFilterFields } from "./fields";

const CoursesFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => coursesFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={5} />;
};

export default CoursesFilter;
